export const prettyFormatDate = (dateString) => {
  if (!dateString) return "Unknown date"; // Handle missing values

  let date;

  // Check if the date is in "YYYY-MM-DD" format (ISO)
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    // Create a local date by splitting the string
    const [year, month, day] = dateString.split("-");
    date = new Date(year, month - 1, day);
  }
  // Check if the date is in "YYYY-MM" format (Year-Month)
  else if (/^\d{4}-\d{2}$/.test(dateString)) {
    const [year, month] = dateString.split("-");
    date = new Date(year, month - 1);
    return new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(date);
  }
  // Check if the date is in "MMMM YYYY" (e.g., June 2019)
  else if (/^[A-Za-z]+ \d{4}$/.test(dateString)) {
    return dateString; // Already in the correct format
  }
  // Check if the date is in "MMMM DD, YYYY" format (e.g., June 14, 2001)
  else if (/^[A-Za-z]+ \d{1,2}, \d{4}$/.test(dateString)) {
    return dateString; // Already in the correct format
  }
  // If it's already a valid Date object
  else if (dateString instanceof Date) {
    date = dateString;
  }
  // Fallback for invalid formats
  else {
    return "Invalid date";
  }

  // If the date is invalid after parsing
  if (isNaN(date)) return "Invalid date";

  // Determine format based on input:
  // If the original string includes a comma or is longer than 7 characters, assume it includes a day.
  const options = {
    year: "numeric",
    month: "long",
    day: dateString.includes(",") || dateString.length > 7 ? "numeric" : undefined,
  };

  return date.toLocaleDateString("en-US", options);
};

export const parseTimelineDate = (dateString) => {
  if (!dateString) return new Date(0);

  // 1. Check YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  // 2. Check YYYY-MM
  if (/^\d{4}-\d{2}$/.test(dateString)) {
    const [year, month] = dateString.split("-").map(Number);
    return new Date(year, month - 1, 1);
  }

  // 3. Check "Month Year" (e.g., "February 2019", "March 1980")
  const monthYearMatch = dateString.match(/^([A-Za-z]+)\s+(\d{4})$/);
  if (monthYearMatch) {
    const [_, monthStr, yearStr] = monthYearMatch;
    const year = parseInt(yearStr, 10);
    const monthNames = [
      "january", "february", "march", "april", "may", "june",
      "july", "august", "september", "october", "november", "december"
    ];
    const monthIndex = monthNames.indexOf(monthStr.toLowerCase());
    if (monthIndex !== -1) {
      return new Date(year, monthIndex, 1);
    }
  }

  // 4. Check "Month Day, Year" (e.g., "March 1, 1978", "December 19, 2017", "August 7, 2002")
  const monthDayYearMatch = dateString.match(/^([A-Za-z]+)\s+(\d{1,2}),\s+(\d{4})$/);
  if (monthDayYearMatch) {
    const [_, monthStr, dayStr, yearStr] = monthDayYearMatch;
    const year = parseInt(yearStr, 10);
    const day = parseInt(dayStr, 10);
    const monthNames = [
      "january", "february", "march", "april", "may", "june",
      "july", "august", "september", "october", "november", "december"
    ];
    const monthIndex = monthNames.indexOf(monthStr.toLowerCase());
    if (monthIndex !== -1) {
      return new Date(year, monthIndex, day);
    }
  }

  // Fallback to native parsing
  const nativeDate = new Date(dateString);
  if (!isNaN(nativeDate.getTime())) {
    return nativeDate;
  }

  return new Date(0);
};